// Chat Widget API Configuration
// Connects to the RAGApp Flask backend

const CHAT_API_CONFIG = {
  production: 'https://raga.technoscion.com:7443',
  staging: 'https://raga.technoscion.com:7443',
  development: 'https://raga.technoscion.com:7443',
};

export const getChatApiBase = () => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost') return CHAT_API_CONFIG.development;
  if (hostname === 'test.maxiomwealth.com') return CHAT_API_CONFIG.staging;
  return CHAT_API_CONFIG.production;
};

export const CHAT_ENDPOINTS = {
  query: () => `${getChatApiBase()}/api/prospect/query`,
  zohoVisitor: (uid) => `${getChatApiBase()}/api/zoho/visitor?user_uniqueid=${encodeURIComponent(uid)}`
};

export default {
  getChatApiBase,
  CHAT_ENDPOINTS
};
